import { render, staticRenderFns } from "./RentalObjectAds.vue?vue&type=template&id=58cccd1f&scoped=true&"
import script from "./RentalObjectAds.vue?vue&type=script&lang=js&"
export * from "./RentalObjectAds.vue?vue&type=script&lang=js&"
import style0 from "./RentalObjectAds.vue?vue&type=style&index=0&id=58cccd1f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cccd1f",
  null
  
)

export default component.exports